import { scriptDefinition } from '../../../types'
import api from './index'

interface ScriptRebuttalInterface {
  slug: string
  contents: APIScriptContentInterface[]
}

interface APIScriptContentInterface {
  disabled: boolean
  order: number
  ordinal: number
  content: string
  title: string
  id: string
  slug: string
  tooltip?: string | null
}

export async function getScriptsAndRebuttalsObject(token: string): Promise<{
  APIScriptsCopy: object
  APIRebuttalsCopy: object
  APIReprogrammingOpportunites: object
}> {
  try {
    const res = await api.get('/agent/rebuttals', {
      headers: { Authorization: `Bearer ${token}` },
    })

    if (res.status !== 200) {
      throw new Error(`Non-200 status: ${res.status}`)
    }

    const allRebuttals =
      res.data.data.rebuttals ??
      ([] as Record<string, APIScriptContentInterface>[])
    const allScripts =
      res.data.data.scripts ??
      ([] as Record<string, APIScriptContentInterface>[])

    const allReprogramming =
      // res.data.data.reprogramming ?? ([] as Record<string, APIScriptContentInterface>[])
      [
        {
          id: '401',
          name: 'En Newhire Payer Ndr',
          slug: 'en_newhire_payer_ndr',
          script: false,
          contents: [
            {
              title: 'I have money in the bank',
              ordinal: 1,
              disabled: false,
              id: '4010',
              slug: 'page-1-reprogramming-1',
              content:
                '<!-- filteredScripts: [1,2,3,4,5,6] --> \n How much more money do you think you would be saving without this debt? ',
              tooltip: 'The only alt text',
            },
            {
              title: 'I’m getting by/ haven’t missed a payment ',
              ordinal: 2,
              disabled: false,
              id: '4011',
              slug: 'page-1-reprogramming-2',
              content:
                '<!-- filteredScripts: [1,2,3,4,5,6] --> \n It sounds like it’s keeping you from saving.',
              tooltip: '',
            },
            {
              title: 'Balances going down',
              ordinal: 1,
              disabled: false,
              id: '4010',
              slug: 'page-1-reprogramming-3',
              content:
                '<!-- filteredScripts: [1,2,3,4,5,6] --> \n Are they going down as fast as you would think for that huge amount of money you’re paying?',
              tooltip: '',
            },
            {
              title: 'How many loans or cards have you applied for recently? ',
              ordinal: 2,
              disabled: false,
              id: '4011',
              slug: 'credit-review-reprogramming-1',
              content:
                '<!-- filteredScripts: [0,2,3,4,5,6] --> \n Did they tell you that you had too much debt to qualify? ',
              tooltip: '',
            },
            {
              title: 'Big payment big balance.',
              ordinal: 1,
              disabled: false,
              id: '4010',
              slug: 'credit-review-reprogramming-2',
              content:
                '<!-- filteredScripts: [0,2,3,4,5,6] --> \n How much are you putting back on the card every month? So you aren’t making any progress. ',
            },
            {
              title: 'Overlimit',
              ordinal: 2,
              disabled: false,
              id: '4011',
              slug: 'credit-review-reprogramming-3',
              content:
                '<!-- filteredScripts: [0,2,3,4,5,6] --> \n Now they are hitting you with fees too. That doesn’t seem very helpful? ',
            },
            {
              title: 'I want to keep that one',
              ordinal: 2,
              disabled: false,
              id: '4011',
              slug: 'budget-review-reprogramming-1',
              content:
                '<!-- filteredScripts: [0,1,3,4,5,6] --> \n We can figure it out.  Isn’t it more important to get approved and have enough savings? ',
            },
            {
              title: 'Why are you asking all these questions?',
              ordinal: 2,
              disabled: false,
              id: '4011',
              slug: 'budget-review-reprogramming-1',
              content:
                '<!-- filteredScripts: [0,1,3,4,5,6] --> \n To make sure you can get approved rather than keep paying all this interest.',
            },
            {
              title: 'Client Swearing',
              ordinal: 2,
              disabled: false,
              id: '4011',
              slug: 'reprogramming-3',
              content:
                "I understand this is a stressful time in your life. I'm only trying to help you.",
            },
          ],
        },
      ] as unknown as ScriptRebuttalInterface[] //this is fine for testing code. When we use the API, we should get the right shape

    const returnScripts = {} as Record<string, Record<string, scriptDefinition>>
    const returnRebuttals = {} as Record<
      string,
      Record<string, scriptDefinition>
    >
    const returnReprogrammingOpportunities = {} as Record<
      string,
      Record<string, scriptDefinition>
    >

    allScripts.forEach((script: ScriptRebuttalInterface) => {
      returnScripts[script.slug] = {}
      script.contents?.forEach((c: APIScriptContentInterface) => {
        if (c.disabled === true) {
          return false
        }
        returnScripts[script.slug][c.title] = {
          disabled: c.disabled,
          order: c.ordinal,
          fileContent: c.content,
          title: c.title,
          id: c.id,
          slug: c.slug,
        }
      })
    })

    allRebuttals.forEach((reb: ScriptRebuttalInterface) => {
      returnRebuttals[reb.slug] = {}
      reb.contents?.forEach((c: APIScriptContentInterface) => {
        const filter = new RegExp(/filteredScripts: \[([0-9, ]*)\]/gm).exec(
          c.content,
        )
        if (c.disabled === true) {
          return false
        }
        returnRebuttals[reb.slug][c.title] = {
          filteredScriptIds:
            filter == null
              ? null
              : filter[1].split(',').map((filterString) => {
                  return filterString.trim()
                }),
          disabled: c.disabled,
          order: c.ordinal,
          fileContent: c.content,
          title: c.title,
          id: c.id,
          slug: c.slug,
        }
      })
    })

    allReprogramming.forEach((rep: ScriptRebuttalInterface) => {
      returnReprogrammingOpportunities[rep.slug] = {}

      rep.contents?.forEach((c: APIScriptContentInterface) => {
        const filter = new RegExp(/filteredScripts: \[([0-9, ]*)\]/gm).exec(
          c.content,
        )
        returnReprogrammingOpportunities[rep.slug][c.title] = {
          filteredScriptIds:
            filter == null
              ? null
              : filter[1].split(',').map((filterString) => {
                  return filterString.trim()
                }),
          disabled: c.disabled,
          order: c.ordinal,
          fileContent: c.content,
          title: c.title,
          id: c.id,
          slug: c.slug,
          tooltip: c.tooltip ? c.tooltip : null,
        }
      })
    })

    return {
      APIScriptsCopy: returnScripts,
      APIRebuttalsCopy: returnRebuttals,
      APIReprogrammingOpportunites: returnReprogrammingOpportunities,
    }
  } catch (err) {
    console.error('getScriptsAndRebuttalsObject failed:', err)
    return {
      APIScriptsCopy: {},
      APIRebuttalsCopy: {},
      APIReprogrammingOpportunites: {},
    }
  }
}

export async function getRebuttalHash(token: string): Promise<string> {
  const checksumPromise = await api
    .get('/agent/rebuttals/checksum', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .catch(() => {
      console.warn('Error communicating with module-manager api')
    })

  if (checksumPromise && checksumPromise.status === 200) {
    return checksumPromise.data.data.checksum
  }

  return ''
}

export async function updateScriptAPICall(
  isScripts: boolean,
  token: string,
  contentSlug: string,
  scriptName: string,
  objectSlug: string,
  updatedText: string,
): Promise<void> {
  await api
    .put(
      `/agent/${isScripts ? 'scripts' : 'rebuttals'}/${objectSlug}/content/${contentSlug}`,
      {
        name: scriptName,
        slug: objectSlug,
        content: updatedText,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .catch(() => {
      console.warn('Error communicating with module-manager api (Update)')
    })
}

export async function getScriptRebuttalHistory(
  isScripts: boolean = true,
  token: string | null,
  objectSlug: string = 'en_newhire_payer_ndr',
  scriptName: string = 'page-1',
) {
  //en_newhire_payer_ndr
  const historyPromise = await api
    .get(
      `/agent/${isScripts ? 'scripts' : 'rebuttals'}/${objectSlug}/content/${scriptName}?include=history`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .catch((err) => {
      console.error(err)
    })

  if (historyPromise && historyPromise.status == 200) {
    return historyPromise.data.data.history
  }

  return {}
}
